import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useToggleState } from 'react-stately';
import { useCheckbox } from 'react-aria';

import { uniqueId } from 'lodash';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './Checkbox.module.scss';

const variantStyles = {
    xs: `govuk-checkboxes govuk-checkboxes--small ${styles.xs}`,
    small: 'govuk-checkboxes govuk-checkboxes--small',
    default: 'govuk-checkboxes'
};

const Checkbox = ({ children, id, small, variant, className, ...props }) => {
    const state = useToggleState(props);
    const ref = useRef();
    const { inputProps } = useCheckbox({ ...props, children }, state, ref);

    const variantClass = variantStyles[variant] || variantStyles.default;
    return (
        <div
            className={[
                styles.checkboxContainer,
                variantClass,
                className
            ].join(' ')}
            data-testid={props['data-testid']}
        >
            <div
                className={[
                    'govuk-checkboxes__item',
                    styles.checkboxWrapper
                ].join(' ')}
            >
                <input
                    id={id}
                    ref={ref}
                    {...inputProps}
                    className={['govuk-checkboxes__input', styles.input].join(' ')}
                    data-testid={props['data-testid'] ? props['data-testid'] + '-input' : null}
                />
                <label
                    className={['govuk-label govuk-checkboxes__label', styles.label].join(' ')}
                    htmlFor={id}
                    data-testid={props['data-testid'] ? props['data-testid'] + '-label' : null}
                >
                    {children}
                </label>
            </div>
        </div>
    );
};

Checkbox.propTypes = {
    ...defaultAriaProps,
    small: PropTypes.bool,
    id: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['xs', 'small', 'default'])
};

Checkbox.defaultProps = {
    id: uniqueId('checkbox_'),
    variant: 'default'
};

export default Checkbox;
